import { render, staticRenderFns } from "./PaymentTable.vue?vue&type=template&id=18831fd9"
import script from "./PaymentTable.vue?vue&type=script&lang=js"
export * from "./PaymentTable.vue?vue&type=script&lang=js"
import style0 from "./PaymentTable.vue?vue&type=style&index=0&id=18831fd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports